// src/services/bankService.js
import axios from '@/api'

export default {
  getAll() {
    return axios.get('/banks')
  },
  create(data) {
    return axios.post('/banks', data)
  },
  get(id) {
    return axios.get(`/banks/${id}`).then(res => res.data.bank)
  },
  update(id, data) {
    return axios.put(`/banks/${id}`, data)
  },
  
  delete(id) {
    return axios.delete(`/banks/${id}`)
  },
  toggleStatus(id) {
    return axios.patch(`/banks/${id}/changeStatus`)
  }
}
